/**
 * @packageDocumentation
 * @module f1/number
 */

export interface Inc {
  /**
   * Increment a value by 1
   *
   * @public
   * @function f1.inc
   * @param v a real number
   * @example
   *
   * ```ts
   * f1.inc(2) => 3
   * ```
   */
  (v: number): number;
}

/**
 * @see Inc
 */
export default (v: number) => v + 1;
